import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface CondicionesClimaticas {
  id?: number; // opcional en creación
  nombre: string;
  estado?: number; // opcional en creación
  fechaCreacion?: string; // lo devuelve el backend
  fechaModificacion?: string | null; // lo devuelve el backend
}

@Injectable({
  providedIn: "root",
})
export class CondicionesClimaticasService {
  private apiUrl = `${environment.apiUrl}/api/condiciones-climaticas`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getCondiciones(): Observable<CondicionesClimaticas[]> {
    return this.http
      .get<CondicionesClimaticas[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getAllCondicionesClimaticasActivas(): Observable<CondicionesClimaticas[]> {
    return this.http
      .get<CondicionesClimaticas[]>(`${this.apiUrl}/activas`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getCondicionById(id: string | number): Observable<CondicionesClimaticas> {
    return this.http
      .get<CondicionesClimaticas>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createCondicion(payload: CondicionesClimaticas): Observable<CondicionesClimaticas> {
    return this.http
      .post<CondicionesClimaticas>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateCondicion(id: string | number, payload: CondicionesClimaticas): Observable<CondicionesClimaticas> {
    return this.http
      .put<CondicionesClimaticas>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteCondicion(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
